module.exports = __webpack_public_path__ + "static/media/Caroline Spencer.c30a3226.png";